module.exports = __webpack_public_path__ + "static/img/bg.b4735631.png";